module.exports = __webpack_public_path__ + "static/ArchitectMaterialImage-1d13ababe01b2d66c5f5927f10ce5cec.jpg";